import React, { useCallback } from 'react'

import Image from 'next/image'
import { useRouter } from 'next/navigation'

import { SectionContainer } from 'Components/Blocks'
import AppearingWrapper from 'Components/Blocks/AppearingWrapper'
import { Button, Column, Row, Text } from 'Components/UI'

import { AboutUsHeroImage } from 'Assets/Images/Sections/AboutUsHeroSection'
import { StripedCircleSvg } from 'Assets/Svg'

import { LANDING_CONTENT_PX } from 'Constants/Landing'
import { OFFER_URL } from 'Constants/Values'

import { useResponsiveLayout } from 'Hooks'

import { Container, Overlay, Title } from './styles'

function AboutUsHeroSection() {
  const { isMobile } = useResponsiveLayout()

  const router = useRouter()

  const handleButtonClick = useCallback(() => {
    router.push(OFFER_URL)
  }, [router])

  return (
    <SectionContainer>
      <Row px={LANDING_CONTENT_PX}>
        <Container mt={5} px={[6, 6, 14, 14, 21]} py={[14, 14, 14, 14, 21]}>
          <Image alt="" src={AboutUsHeroImage} />

          <Overlay />

          <Column
            alignCenter={isMobile}
            alignStart={!isMobile}
            gap={6}
            width={[1, 1, 1 / 2]}
          >
            <AppearingWrapper centered={isMobile} kind="expand">
              <Title flexDirection={['column', 'column', 'row']}>
                {StripedCircleSvg()}

                <Text as="h1" bold center={isMobile} inverse screen18>
                  The new age of golf is here. Come join us!
                </Text>
              </Title>
            </AppearingWrapper>

            <Text
              as="h3"
              bold
              center={isMobile}
              inverse
              mb={5}
              mt={3}
              screen40={isMobile}
              screen52={!isMobile}
            >
              About Emajin Golf
            </Text>

            <Text
              center={isMobile}
              inverse
              mb={7}
              screen14={isMobile}
              screen20={!isMobile}
            >
              Joining Emajin Golf Networking Club means you’ll be playing golf
              with incredible people, at some of the best golf courses in
              Australia
            </Text>

            <Button large mb={6} onClick={handleButtonClick}>
              Membership Options
            </Button>
          </Column>
        </Container>
      </Row>
    </SectionContainer>
  )
}

export default AboutUsHeroSection
